import * as Yup from 'yup';

export const stateValidationSchema = Yup.object().shape({
    
});
